import { useMatch } from "react-router-dom";

/**
 * Returns true if the current route is a home route.
 * A home route is any route that is a child of the root route.
 * This includes:
 * - /
 * - /staff
 * - /o/:tenantId
 */
export function useHomeRoute() {
  const rootMatch = useMatch("/");
  const staffMatch = useMatch("/staff");
  const tenantMatch = useMatch("/o/:tenantId");

  return Boolean(rootMatch) || Boolean(staffMatch) || Boolean(tenantMatch);
}
